import { Component, OnInit, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { LoadingService } from './shared/services/loading.service';

@Component({
  standalone: false,
  selector: 'cars-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'rieker-car-ui';
  isLoader = signal(false);

  private destroyRef = inject(DestroyRef);

  constructor(
    private _router: Router,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.routerEvents();
    this.listenToLoading();
  }

  listenToLoading(): void {
    this.loadingService.loadingSub
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => this.isLoader.set(result));
  }

  routerEvents() {
    this._router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.loadingService.loadingSub.next(true);
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.loadingService.loadingSub.next(false);
        }
      });
  }
}